import "../styles.css";

const ParagraphTwo = () => {
  return <div className="par-two-loader-container"></div>;
};

export default ParagraphTwo;
